export function reorderList<T>(list:T[], sourceIdx: number, destIdx: number) {
  const result = Array.from(list);
  const [removed] = result.splice(sourceIdx, 1);
  result.splice(destIdx, 0, removed);

  return result;
}